/** Main project script */

// ensure the main object is defined
if (typeof(so) === 'undefined') {
    var so = {};
}

// main code
so.cdow = {
    init: function() {
        this.mobileMenu();
        this.multiMenuTrigger();
        this.toggleSearch();
        this.containerLink();
        this.scrollDown();
        this.swipeboxInit();
        this.highlightActive();
    },
    toggleOpenClass: function(target, openClass) {
        if (openClass == undefined) {
            openClass = 'open';
        }

        if ($(target).hasClass(openClass)) {
            $(target).removeClass(openClass);
        } else {
            $(target).addClass(openClass);
        }
    },
    multiMenuTrigger: function() {
        $("#menu-trigger").click(function() {
            so.cdow.toggleOpenClass($(".primary-menu"));
            so.cdow.toggleOpenClass($(".mobile-menu"));
            so.cdow.toggleOpenClass($(".mobile-trigger"));
            $('body').toggleClass('overflow-hidden overflow-md-visible');
        });
    },
    mobileMenu: function() {
        $(".menu-item-submenu-toggle").click(function(e) {
            e.preventDefault();

            var target = $(".mobile-menu ." + $(this).attr('data-trigger'));

            so.cdow.toggleOpenClass(target);
        });

        $(".menu-item-link").click(function() {
            so.cdow.toggleOpenClass($(".mega-menu-small"));
        });
    },
    toggleSearch: function() {
        $("#search-trigger").click(function() {
            $(".search-box").addClass('open');
            $("#SearchForm_SearchForm_Search").focus();
        });
    },
    containerLink: function() {
        $("[data-link]").click(function() {
            var href = $(this).attr('data-link');

            if (href) {
                window.location = href;
            }

            return false;
        });
    },
    swipeboxInit: function() {
        $('.swipebox').swipebox({
            loopAtEnd: true,
            hideBarsDelay : 0,
            afterOpen: function() {
                var $selectorClose = $("#swipebox-close");
                var clickAction = "touchend click";

                $selectorClose.unbind(clickAction);

                $selectorClose.bind(clickAction, function(event) {
                    event.preventDefault();
                    event.stopPropagation();

                    $.swipebox.close();
                });
            }
        });
    },
    scrollDown: function() {
        $(".scroll-down-trigger").click(function() {
            $('html,body').animate({
                scrollTop: $(window).innerHeight() - 140 + 'px'
            }, 1000);
        });
    },
    highlightActive() {
        var url = window.location;
        var element = $('ul.top-level a').filter(function () {
            return this.href == url || url.href.indexOf(this.href) == 0;
        });

        $(element).parentsUntil('ul.top-level', 'li').children('a').addClass('bc-highlight');

        $('.mobile-nav-ul a:not(.home-link)').filter(function () {
            return this.href == url || url.href.indexOf(this.href) == 0;
        }).addClass('c-highlight').parent().addClass('open');
    }
};

$(document).ready(function () {
    so.cdow.init();
});
